import React from 'react';
import * as S from './styled';
export const HighlightedBox = ({ text, size = 'medium' }) => {
    return React.createElement(S.Container, { "$size": size }, text);
};
